import React, { useEffect, useState } from 'react';
import { Clock, Flame } from 'lucide-react';
const START_SECONDS = 8 * 3600 + 49 * 60 + 55;
const CLAIMED_PERCENT = 81;
function pad(value: number) {
  return value.toString().padStart(2, '0');
}
export function UrgencySection() {
  const [secondsLeft, setSecondsLeft] = useState(START_SECONDS);
  useEffect(() => {
    const interval = window.setInterval(() => {
      setSecondsLeft(previous => previous > 0 ? previous - 1 : 0);
    }, 1000);
    return () => window.clearInterval(interval);
  }, []);
  const hours = Math.floor(secondsLeft / 3600);
  const minutes = Math.floor(secondsLeft % 3600 / 60);
  const seconds = secondsLeft % 60;
  return <section className="py-16 px-4 bg-brand" data-id="element-227" data-mp="3l78bnpgqecmt">
      <div className="max-w-3xl mx-auto text-center" data-id="element-228" data-mp="3l8jglslwxqfi">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-cream mb-2" data-id="element-229" data-mp="1uuiwyuladinj">The launch price ends soon.</h2>
        <p className="text-cream/70 text-sm mb-8" data-id="element-230" data-mp="1qtpckb71ylze">After this, the price goes up and does not come back down.</p>

        <div className="flex justify-center gap-3 md:gap-4 mb-10" role="timer" aria-label={`${hours} hours, ${minutes} minutes and ${seconds} seconds remaining`} data-id="element-231" data-mp="2supm62cpnxya">
          {[{
          value: hours,
          label: 'hrs'
        }, {
          value: minutes,
          label: 'min'
        }, {
          value: seconds,
          label: 'sec'
        }].map(unit => <div key={unit.label} className="bg-cream border border-gold rounded-xl w-20 md:w-24 py-3 flex flex-col items-center" data-id="element-232" data-mp="3ci6u1xq3xsmt">
              <span className="text-2xl md:text-3xl font-bold text-brand tabular-nums" data-id="element-233" data-mp="3gl3dfqnh1srt">{pad(unit.value)}</span>
              <span className="text-[11px] uppercase tracking-widest text-mist-text" data-id="element-234" data-mp="3qh6h50xz1zgv">{unit.label}</span>
            </div>)}
        </div>

        <div className="bg-cream rounded-2xl border border-mist p-6 text-left" data-id="element-235" data-mp="1r5m2hbq2srmq">
          <div className="flex items-center justify-between mb-3" data-id="element-236" data-mp="1w4gm2fvvak7w">
            <span className="flex items-center gap-2 text-brand font-bold text-sm" data-id="element-237" data-mp="1o2g0gd5kswo2">
              <Flame size={16} className="text-gold-dark" aria-hidden="true" data-id="element-238" data-mp="1o4iy9jcyzu3c" /> Launch Price Spots Remaining
            </span>
            <span className="flex items-center gap-1.5 text-mist-text text-xs" data-id="element-239" data-mp="1y1ezr54gbfye">
              <Clock size={12} aria-hidden="true" data-id="element-240" data-mp="1t1so3049u7rp" /> Only a few left
            </span>
          </div>
          <div className="h-3 rounded-full bg-sand overflow-hidden" role="presentation" data-id="element-241" data-mp="271k6dd1tmabi">
            <div className="h-full bg-gold-gradient" style={{
            width: `${CLAIMED_PERCENT}%`
          }} data-id="element-242" data-mp="26z7iykdan7r2" />
          </div>
          <p className="text-sm text-ink/70 mt-3" data-id="element-243" data-mp="2gr3r6o93ge90">{CLAIMED_PERCENT}% of spots have been claimed</p>
        </div>
      </div>
    </section>;
}